<google-map [location]="location.googleLocation" [label]="'You'" (positionChanged)="reposition($event)"></google-map>